export enum DataHubEntities {
  Home = 'home',
  Admin = 'admin',
  Search = 'search',
  Profile = 'profile',
  ProductConsume = 'product_consume',
  Community = 'community'
}
